import { useCallback, useEffect, useRef} from 'react';

const useResize=()=>{
    
    const observer= useRef();
    const callback=useRef();
    const element=useRef();

    if( !observer.current )observer.current=new ResizeObserver((entries)=>{
        for(let entry of entries){
            if(entry.target === element.current) callback.current?.( element.current );
        }
    })

    useEffect(()=>{

        return ()=>{
            observer.current?.disconnect();
        }

    },[]);

    const attachObserver= useCallback ( ( node )=>{
        if( !node )return;
        if( node === element.current ) return;
 
        if(element.current instanceof HTMLElement)observer.current.unobserve(element.current);
        
        element.current = node;

        observer.current.observe(element.current);
        
    }, [] )


    const observe=(cb)=>{
        if(cb instanceof Function)callback.current=cb;
        return {
            ref: attachObserver
        };
    }

  

    return {observe};

}

export {useResize};